export default {
  en: {
    title: 'News & Updates',
    newsOverview: 'Stay up to date with our latest company and industry news.',
    featured: 'Featured News',
    latestNews: 'Latest News',
    readMore: 'Read More',
    published: 'Published on',
    category: 'Category',
    allNews: 'All News',
    categories: {
      all: 'All News',
      company: 'Company News',
      industry: 'Industry News',
      product: 'Product News'
    },
    articles: {
      1: {
        title: 'Global Market Expansion',
        summary: 'Expanding our presence in key international markets to better serve global customers.',
        content: '<p>We are excited to announce our strategic expansion into key international markets. This expansion marks a significant milestone in our company\'s growth and demonstrates our commitment to serving customers worldwide.</p><h3>Key Markets</h3><p>Our expansion focuses on several key regions:</p><ul><li>Southeast Asia</li><li>South America</li><li>Eastern Europe</li><li>Africa</li></ul><h3>Investment and Infrastructure</h3><p>We are investing in local infrastructure and building strong partnerships to ensure we can provide the same high level of service our customers expect from us globally.</p><h3>Future Plans</h3><p>This expansion is just the beginning. We have ambitious plans for further growth and development in these regions, including:</p><ul><li>Establishing regional headquarters</li><li>Building local service centers</li><li>Developing region-specific products</li><li>Creating job opportunities</li></ul>'
      },
      2: {
        title: 'New Technology Integration',
        summary: 'Integrating cutting-edge technology to enhance product performance and user experience.',
        content: '<p>We are proud to announce the successful integration of several cutting-edge technologies into our product line. These advancements represent our ongoing commitment to innovation and excellence in agricultural machinery.</p><h3>Key Innovations</h3><ul><li>Advanced GPS Guidance Systems</li><li>Smart Power Management</li><li>IoT Integration</li><li>Automated Operation Features</li></ul><h3>Benefits</h3><p>These technological improvements bring numerous benefits to our customers:</p><ul><li>Increased efficiency and productivity</li><li>Reduced operating costs</li><li>Enhanced precision and accuracy</li><li>Improved user experience</li></ul><h3>Future Development</h3><p>Our R&D team continues to explore new technologies and innovations to further enhance our products and services.</p>'
      },
      3: {
        title: 'Exclusive Interview with CEO',
        summary: 'Our CEO shares insights on company vision and future development plans.',
        content: '<p>In an exclusive interview, our CEO discusses the company vision, achievements, and plans for the future. This comprehensive discussion provides valuable insights into our strategic direction and commitment to innovation.</p><h3>Vision and Strategy</h3><p>Our CEO emphasizes the importance of sustainable development and technological innovation in shaping the future of agriculture. Key points include:</p><ul><li>Focus on sustainable practices</li><li>Investment in R&D</li><li>Global market expansion</li><li>Customer-centric approach</li></ul><h3>Future Plans</h3><p>The interview reveals several exciting initiatives planned for the coming years:</p><ul><li>New product launches</li><li>Enhanced service offerings</li><li>Expanded global presence</li><li>Technological advancements</li></ul><h3>Industry Leadership</h3><p>Our commitment to leading the industry through innovation and excellence remains stronger than ever.</p>'
      }
    }
  },
  zh: {
    title: '新闻动态',
    newsOverview: '了解我们最新的公司和行业新闻。',
    featured: '特色新闻',
    latestNews: '最新新闻',
    readMore: '阅读更多',
    published: '发布于',
    category: '分类',
    allNews: '全部新闻',
    categories: {
      all: '全部新闻',
      company: '公司动态',
      industry: '行业洞察',
      product: '产品更新'
    },
    articles: {
      1: {
        title: '全球市场扩张',
        summary: '扩大在主要国际市场的业务，为全球客户提供更好的服务。',
        content: '<p>我们很高兴地宣布在主要国际市场的战略扩张计划。这一扩张标志着我司发展的重要里程碑，展示了我们服务全球客户的决心。</p><h3>重点市场</h3><p>我们的扩张主要集中在以下几个关键地区：</p><ul><li>东南亚</li><li>南美洲</li><li>东欧</li><li>非洲</li></ul><h3>投资和基础设施</h3><p>我们正在投资本地基础设施并建立强大的合作伙伴关系，确保能够在全球范围内提供客户期望的高水平服务。</p><h3>未来计划</h3><p>这次扩张仅仅是开始。我们在这些地区还有更多雄心勃勃的发展计划，包括：</p><ul><li>建立区域总部</li><li>设立本地服务中心</li><li>开发区域特色产品</li><li>创造就业机会</li></ul>'
      },
      2: {
        title: '新技术整合',
        summary: '整合前沿技术，提升产品性能和用户体验。',
        content: '<p>我们很自豪地宣布成功将多项前沿技术整合到我们的产品线中。这些进步体现了我们在农业机械领域持续创新和追求卓越的承诺。</p><h3>主要创新</h3><ul><li>先进的GPS导航系统</li><li>智能电源管理</li><li>物联网集成</li><li>自动化操作功能</li></ul><h3>优势</h3><p>这些技术改进为我们的客户带来诸多好处：</p><ul><li>提高效率和生产力</li><li>降低运营成本</li><li>提升精确度和准确性</li><li>改善用户体验</li></ul><h3>未来发展</h3><p>我们的研发团队将继续探索新技术和创新，进一步提升我们的产品和服务。</p>'
      },
      3: {
        title: 'CEO独家专访',
        summary: '我们的CEO分享了公司愿景和未来发展计划。',
        content: '<p>在这次独家专访中，我们的CEO讨论了公司的愿景、成就和未来计划。这次全面的讨论为我们的战略方向和创新承诺提供了宝贵的见解。</p><h3>愿景和战略</h3><p>我们的CEO强调了可持续发展和技术创新在塑造农业未来方面的重要性。主要观点包括：</p><ul><li>注重可持续发展实践</li><li>加大研发投入</li><li>全球市场扩张</li><li>以客户为中心的方针</li></ul><h3>未来计划</h3><p>专访揭示了未来几年的几项令人兴奋的计划：</p><ul><li>新产品发布</li><li>增强服务供应</li><li>扩大全球布局</li><li>技术进步</li></ul><h3>行业领导力</h3><p>我们通过创新和卓越引领行业的承诺比以往任何时候都更加坚定。</p>'
      }
    }
  }
}